import QueryFloors from "graphql/queries/QueryFloors";
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'

export default class FetchFloor
{
	static fetchAll( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) {
		GraphqlGroupedBuilder.addQuery( 'floors', QueryFloors, {
			resultPath: [ 'floors' ],
			callbackStart,
			callbackError,
			callbackSuccess
		})
	}
}
